// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a731ec05","455":"f0a0d358","557":"5346abbc"}[chunkId] + ".chunk.js";
};